/* global axios */

const userAuthLogReports = {
  getReports(accountId, params) {
    return axios.get(`/api/v2/accounts/${accountId}/reports/user_auth_log`, { params });
  },
  downloadCSV(accountId, params) {
    return axios.get(`/api/v2/accounts/${accountId}/reports/user_auth_log_download`, {
      params,
      responseType: 'blob',
    });
  },
};

export default userAuthLogReports;
